"use client"

import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import LoginPopup from "./login-popup"

export default function NavigationLoginHandler() {
  const [showLoginFromNavigation, setShowLoginFromNavigation] = useState(false)
  const location = useLocation()

  useEffect(() => {
    // Show login popup if navigation state requests it
    if (location.state?.showLogin) {
      setShowLoginFromNavigation(true)
      // Clear the state to prevent showing popup again on refresh
      window.history.replaceState({}, document.title)
    }
  }, [location])

  if (!showLoginFromNavigation) {
    return null
  }

  return <LoginPopup onClose={() => setShowLoginFromNavigation(false)} redirectTo={location.state?.from?.pathname} />
}
